var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeNaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#E1BE5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_6948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_6948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6812 21.2906L36.5375 17.1469C36.325 16.9344 36.0594 16.8281 35.7937 16.8281H31.4375C30.8531 16.8281 30.375 17.3062 30.375 17.8906V26.3906C30.375 26.7625 30.7469 27.0281 31.1187 26.8687C31.8625 26.55 32.7125 26.3906 33.5625 26.3906C35.9531 26.3906 38.025 27.7188 39.1406 29.6844C39.3 29.95 39.6719 30.0562 39.9375 29.8438C40.575 29.2594 41 28.4094 41 27.4531V22.0344C41 21.7688 40.8937 21.5031 40.6812 21.2906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5625 35.9531C35.3229 35.9531 36.75 34.526 36.75 32.7656C36.75 31.0052 35.3229 29.5781 33.5625 29.5781C31.8021 29.5781 30.375 31.0052 30.375 32.7656C30.375 34.526 31.8021 35.9531 33.5625 35.9531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.125 12.0469H8.0625C7.47812 12.0469 7 12.525 7 13.1094V27.4531C7 28.4094 7.425 29.2594 8.0625 29.8438C8.32812 30.0562 8.7 30.0031 8.85938 29.6844C9.92188 27.7188 12.0469 26.3906 14.4375 26.3906C17.0938 26.3906 19.325 27.9844 20.3344 30.3219C20.4406 30.5344 20.6 30.6406 20.8125 30.6406H24C25.7531 30.6406 27.1875 29.2062 27.1875 27.4531V13.1094C27.1875 12.525 26.7094 12.0469 26.125 12.0469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 35.9531C16.1979 35.9531 17.625 34.526 17.625 32.7656C17.625 31.0052 16.1979 29.5781 14.4375 29.5781C12.6771 29.5781 11.25 31.0052 11.25 32.7656C11.25 34.526 12.6771 35.9531 14.4375 35.9531Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeNaf);
export default __webpack_public_path__ + "static/media/codeNaf.8d2d8006e80a9f481662895f6414c497.svg";
export { ForwardRef as ReactComponent };